import React, { useCallback, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import completedImage from "../../assests/images/Completed.png";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import LayersIcon from "@mui/icons-material/Layers";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import purchaseImage from "../../assests/images/Purchase.png";
import pendingImage from "../../assests/images/Pending.png";
import shippedImage from "../../assests/images/Shipped.png";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import holdImage from "../../assests/images/hold.png";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import recallmage from "../../assests/images/recall.png";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import checkImage from "../../assests/images/check-circle.png";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import { getSecPermission, isEmptyDash, returnRateVal, returnZero, strToDate, totalInr, trimString } from "../../constant";
import Tooltip from '@mui/material/Tooltip';
import { lrServices } from "../../services/lrServices";
import _ from "lodash";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import Filter from "../filter/filter";
import { commonServices } from "../../services/commonServices";
import { purchaseOrderServices } from "../../services/purchaseOrderServices";
import TrackOrder from "../common/trackOrder";
import P2PDownload from "../common/p2pDownload";

const initialColumns = [
  { id: "lrNumber", label: "LR Number", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "transporterLrNumber", label: "Transporter LR Number", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "vendorCode", label: "Vendor Code", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "pos", label: "POs", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "origin", label: "Origin", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "destination", label: "Destination", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "transporterName", label: "Transporter Name", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "vehicleNumber", label: "Vehicle No", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "driverName", label: "Driver Name", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "eWayBillNo", label: "E-way Bill Number", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "eInvoiceNo", label: "E-Invoice", isSort: true, sortLabel: "", formate: "TEXT"  },
  
  { id: "createdBy", label: "Created By", isSort: true, sortLabel: "", formate: "TEXT" },
  { id: "createdAt", label: "Created On", isSort: true, sortLabel: "", formate: "DATE" },
  { id: "updatedAt", label: "Updated On", isSort: true, sortLabel: "", formate: "DATE" },

  { id: "quantity", label: "Quantity", isSort: true, sortLabel: "", formate: "TEXT"  },
  { id: "lrDate", label: "LR Date", isSort: true, sortLabel: "", formate: "DATE"  },
  { id: "expectedDeliveryDate", label: "Expected Delivery", isSort: true, sortLabel: "", formate: "DATE"  },
  { id: "totalValue", label: "Total Value", isSort: true, sortLabel: "" , formate: "RATE"},
  { id: "col15", label: "Action" },
];

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};


const permissionInit = {
  create: false,
  read: false,
  update: false,
  delete: false,
};
function LrListing() {

  const qcListing = {
    currentPage: 1,
    totalPages: 20,
  }

  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const [isLoading, setIsLoading] = useState(false);
  const [lrlisting, setLRListing] = React.useState({
    totalPages: 0,
    currentPage: 1,
    totalItems: 0,
    lorryReceipts: [],
  });

  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [filterText, setFilterText] = useState("");
  const [selectedPOArr, setSelectedPOArr] = useState([]);
  const [selectedPOJsonArr, setSelectedPOJsonArr] = useState([]);
  const [filterFormData, setFilterFormData] = useState("");

  const [trackOrderData, setTrackOrderData] = useState("");
  const [selectLRId, setSelectedLRId] = useState(false);
  const [secLRPermission, setSecLRPermission] = useState({
    "LR_LISTING": permissionInit,
    "LR_DETAIL": permissionInit,
    "CREATE_LR": permissionInit,
    "TRACK_ORDER_LR": permissionInit,
    "EDIT_LR": permissionInit,
    "DOWNLOAD_LR": permissionInit,
  });

  const [inputPage, setInputPage] = useState(qcListing?.currentPage || 1);
  const [summary, setSummary] = React.useState({});

  // const onPaginationChange = (e, value) => {
  //   // let requestPayloadInit = _.cloneDeep(requestPayload);
  //   // requestPayloadInit.pageNumber = value;
  //   // setRequestPayload(requestPayloadInit); 
  // }
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= qcListing?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(qcListing?.currentPage);
      }
    }
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [downloadEl, setdownloadEl] = React.useState(null);
  const [opengateentry, setOpenGateEntry] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const download = Boolean(downloadEl);
  const handleClicks = (event) => {
    setdownloadEl(event.currentTarget);
  };
  const handleCloses = () => {
    setdownloadEl(null);
  };
  const [columns, setColumns] = useState(initialColumns);

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedColumns = Array.from(columns);
    const [removed] = reorderedColumns.splice(result.source.index, 1);
    reorderedColumns.splice(result.destination.index, 0, removed);

    setColumns(reorderedColumns);
  };
  const reducer = (state, action) => {
    switch (action.type) {
      case "TOGGLE_DRAWER":
        return { ...state, open: action.newOpen };
      default:
        throw new Error(`Unknown action: ${action.type}`);
    }
  };
  const [state, dispatch] = React.useReducer(reducer, { open: false });
  const toggleDrawer = (newOpen) => () => {
    dispatch({ type: "TOGGLE_DRAWER", newOpen });
  };
  // const onSortChange = (index, sortBy, sortOrder) => {
  //   let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
  // }

  let navigate = useNavigate();
  const navigateUrl = (param) => {
    navigate(param);
  };

  useEffect(() => {
    getLRListing(requestPayload, filterText, filterFormData);
  }, [requestPayload]);


  useEffect(() => {
    let secLRPermissionInit = _.cloneDeep(secLRPermission);
    let obj = {};
    for (let key in secLRPermissionInit) {
      obj[key] = getSecPermission(key);
    }
    setSecLRPermission(obj);
    getSummary("?uniqueName=LORRY_RECEIPT");

  }, []);

  const getSummary = (param) => {
    setIsLoading(true);
    let promise = commonServices.getSummary(param);
    promise.then((res) => {
      if (res.data.success === true) {
        setSummary(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const getLRListing = (requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    const filteredFormData = formData ? Object.entries(formData)
      .filter(([key, value]) => value !== '')
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {}) : {};
    if (filteredFormData && Object.keys(filteredFormData).length > 0) {
      Object.entries(filteredFormData).forEach(([key, value]) => {
        param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
    }

    let promise = lrServices.getLRListing(param);
    promise.then((res) => {
      if (res.data.success === true) {
        setLRListing(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };


  const redirectToDetails = (redirectId) => {
    const UserObjInit = JSON.parse(sessionStorage.getItem('user'));
    let param = {
      requestPayload: requestPayload,
      filterText: filterText,
      filterFormData: filterFormData,
      componentName: "LR_LIST",
    };
    UserObjInit["prevLocationData"] = param;
    sessionStorage.setItem("user", JSON.stringify(UserObjInit));
    navigateUrl(`/admin/vendor-LR-Deatil/${redirectId}`);
  };

  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };
  const onFilterSubmit = () => {
    getLRListing(requestPayload, filterText);
  };

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
    }, 800),
    []
  );

  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;

    for (let i = 0; i < columnsInit.length; i++) {
      columnsInit[i].sortLabel = "";
      if (i == index) {
        columnsInit[i].sortLabel = newSortLael;
      }
    }

    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
  }
  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
  }

  const handleFilterFormSubmit = (formDataa) => {
    setFilterFormData(formDataa);
    const updatedPayload = {
      ...requestPayload,
      searchCriteria: formDataa,
    };
    setRequestPayload(updatedPayload);
    getLRListing(updatedPayload, filterText, formDataa || '');
  };

  const handleResetFormSubmit = () => {
    setFilterFormData(null);
    getLRListing(requestPayload, filterText, {});
  }

  const onLRCheckChange = (value, row, rowIndex) => {
    let lrListingInit = _.cloneDeep(lrlisting);
    lrListingInit.lorryReceipts[rowIndex].isChecked = value;
    let arr = [];
    let jsonArr = [];
    let purchaseOrderID = [];
    for (let i = 0; i < lrListingInit.lorryReceipts.length; i++) {
      if (lrListingInit.lorryReceipts[i].isChecked == true) {
        arr.push(lrListingInit.lorryReceipts[i]._id);
        jsonArr.push(lrListingInit.lorryReceipts[i]);
        purchaseOrderID.push(lrListingInit.lorryReceipts[i].purchaseOrderId);
      }
    }
    setSelectedPOArr(arr);
    setSelectedPOJsonArr(jsonArr);
    setLRListing(lrListingInit);
    setSelectedLRId(purchaseOrderID);
  }

  const handleTrackOrder = () => {
    if (selectedPOArr.length < 1) {
      setAlertComponent({ open: true, type: "error", message: `Please select atleast one LR. ` });
      return;
    }
    setIsLoading(true);
    purchaseOrderServices.getPOTrackOrder(selectLRId)
      .then(response => {
        if (response?.data?.success == true) {
          toggleDrawer(true)();
          setTrackOrderData(response?.data?.data);
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}. ` });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const DrawerList = (
    <TrackOrder steps={trackOrderData} close={() => toggleDrawer(false)()} refresh={() => handleTrackOrder()} />
  );

  return (
    <>
      <div className="login-forms">
        <div className="text-centers row_purchase_invoice_dragdropcontext_apps_body">
          <div>
            <div className="search_filter_outerse ms-auto">
              <div className="search_main">
                <h5>LR Listing</h5>
              </div>
              <div className="vendor_listing_lr_block_body" style={{alignItems: "center"}}>
                {(secLRPermission?.CREATE_LR?.read == true) && <button className="create_btn_lr_creations" onClick={() => navigateUrl(`/admin/vendor-LR-Creation`)}>
                  {/* <Link
                    style={{ color: "white", textDecoration: "none" }}
                    to="/admin/vendor-LR-Creation"
                  > */}
                    Create LR
                  {/* </Link> */}
                </button>}
                
                {(secLRPermission?.DOWNLOAD_LR?.read == true) && <P2PDownload
                  url={`/v1/common/lorry-receipts/download`}
                  selectedArr={selectedPOArr}
                  selectedPOJsonArr={selectedPOJsonArr}
                  filterFormData={filterFormData}
                  filterText={filterText}
                  type="LR"
                />}
                {/* <button
                onClick={() => {
                  setOpenGateEntry(true);
                }}
                className="create_btn_lr_creations"
              >
                Create Gate Entry
              </button> */}
                {/* <button className="btn btn-danger" style={{ borderRadius: "6px" }}>Cancel</button> */}
              </div>
            </div>
            <div className="account_ledger_listing_row1">
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total LR
                    </label>
                    <p className="block_detail_listing">
                      <b>{summary?.total}</b>
                    </p>
                  </div>
                 <img className="purchase_images_letscom"
                    src={purchaseImage}
                    alt=""
                  />
                </div>
              </div>
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Pending LR
                    </label>
                    <p className="block_detail_listing">
                      <b>{summary?.pending}</b>
                    </p>
                  </div>
                 <img className="purchase_images_letscom"
                    src={pendingImage}
                    alt=""
                  />
                </div>
              </div>
              {/* <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Shipped Order
                    </label>
                    <p className="block_detail_listing">
                      <b>0</b>
                    </p>
                  </div>
                <img className="purchase_images_letscom"
                    src={shippedImage}
                    alt=""
                  />
                </div>
              </div> */}
              {/* <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Completed Order
                    </label>
                    <p className="block_detail_listing">
                      <b>0</b>
                    </p>
                  </div>
              <img className="purchase_images_letscom"
                    src={completedImage}
                    alt=""
                  />
                </div>
              </div> */}
            </div>
            <div className="search_filter_outers ms-auto">
              <div className="search_main">
                <div id="custom-search-input">
                  <div className="input-group col-md-12">
                    <input
                      type="text"
                      className="form-control input-lg"
                      placeholder="Search here"
                      fdprocessedid="8achb"

                      onChange={onFilterTextChange}
                      value={filterText}
                      onKeyPress={onKeyPressHandler}
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-info btn-lg"
                        type="button"
                        fdprocessedid="trsp06"
                      >
                        <span className="glyphicon glyphicon-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                          </svg>
                        </span>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div className="bpdt_po_order_react">
              {/* {(secLRPermission?.TRACK_ORDER_LR?.read == true) && <div>
                  <button className="btn btn-outline-secondary" onClick={handleTrackOrder}>Track Order</button>
                  <Drawer
                    anchor="right"
                    open={state.open}
                    onClose={toggleDrawer(false)}
                    style={{ zIndex: 99999 }}
                  >
                    {DrawerList}
                  </Drawer>
                </div>} */}
                <div className="row_filterrbtnvendor_box">
                  <div className="lets_filter_vendorlist_body_detail">
                    <FilterAltIcon />
                    <Filter uniqueName={"LORRY_RECEIPT"} formSubmitFunction={handleFilterFormSubmit} resetFilter={handleResetFormSubmit} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" direction="horizontal">
              {(provided) => (
                <div style={{ width: "100%", overflow: "hidden" }}
                  className="listing_main listing_main_dragdropcontext_body"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  <table className="dragdropcontext_ondragend_block_row">
                    <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                      <tr>
                        <th className="vendor_tabels">
                          {/* <input type="checkbox" /> */}
                        </th>
                        {columns.map((column, index) => (
                          <Draggable
                            key={column.id}
                            draggableId={column.id}
                            index={index}
                          >
                            {(provided) => (
                              <th
                                className="vendor_tabels"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                {column.label}
                                {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                                  {/* <SwapVertIcon className="swap-sort-ico" /> */}
                                  {(column.sortLabel != "asc") && <img src={topArrow} />}
                                  {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                  {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                                  {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                </span>}
                              </th>
                            )}
                          </Draggable>
                        ))}
                      </tr>
                    </thead>
                    <tbody style={{ overflowY: "scroll", width: "200px" }}>
                      {lrlisting?.lorryReceipts.length < 1 && <>
                        <tr>
                          <td colSpan={10} className="text-center list-no-data">No Data Found</td>
                        </tr>
                      </>}
                      {lrlisting?.lorryReceipts?.map((row, rowIndex) => (
                        <tr key={rowIndex} className="maine_tr_vendor">
                          <td>
                            <input type="checkbox" checked={row.isChecked} onChange={(e) => onLRCheckChange(e.target.checked, row, rowIndex)} />
                          </td>

                          {columns.map((column, index) => (<>
                            {(column.id == "lrNumber") ? (<td>
                              <p className="list-details-para" onClick={() => redirectToDetails(row?._id)}>
                                {row[column.id]}
                              </p>
                            </td>) : (column?.formate == "DATE") ? (<td>
                              <p  >
                                {isEmptyDash(row[column.id]) ? "N/A" : strToDate(row[column.id])}
                              </p>
                            </td>) :
                            (column?.formate == "RATE") ?
                            <td>
                              {returnRateVal(row[column?.id])}
                              {/* ₹{totalInr(returnZero(row[column?.id]))}  */}
                              </td> :
                              
                             <td key={index} >
                              <Tooltip title={row[column.id] || "N/A"}>
                              {trimString(row[column.id], 20 || "N/A")}
                              </Tooltip>
                            </td>
                            }

                            {/* <td key={column.id}>{row[column.id]}</td> */}
                          </>
                          ))}
                          {/* {columns.map((column, index) => (
                            <td
                              key={index}
                              className={
                                index === 0 || index === 1 ? "block_solar" : ""
                              }
                            >
                              {row[column.id]}
                            </td>
                          ))} */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          
          {lrlisting?.lorryReceipts.length > 0 && <>
          <div className="lets_pagination_package_listing_react">
            <div className="pagination_select_react_packagelr_detail">
              <select
                className="form-select packagelrlisting from-hs"
                onChange={onPageSizeChange}
                value={requestPayload?.pageSize}
              >
                <option selected="1">10</option>
                <option value="2">15</option>
                <option value="3">20</option>
                <option value="4">25</option>
                <option value="5">50</option>
              </select>
              <span className="react_text_showing">
                {` Showing rows ${Number(lrlisting?.pageSize) * Number(lrlisting?.currentPage - 1) + 1} to ${Number(lrlisting?.pageSize) * Number(lrlisting?.currentPage - 1) + Number(lrlisting?.lorryReceipts?.length)} of ${lrlisting?.totalItems}`}
              </span>
            </div>
            <Stack spacing={2}>
              <Pagination
                count={lrlisting?.totalPages}
                page={lrlisting?.currentPage}
                onChange={(event, page) => {
                  setInputPage(page);
                  onPaginationChange(event, page);
                }}
                renderItem={(item) => {
                  if (item.page === lrlisting?.currentPage) {
                    return (
                      <input
                        className="form-control listing_currentpagination"
                        type="text"
                        value={inputPage}
                        onChange={handleInputChange}
                        onKeyDown={handleInputSubmit}
                      />
                    );
                  }
                  return (
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  );
                }}
              // count={5}
              // renderItem={(item) => (
              //   <PaginationItem
              //     className="pagination_react_listings"
              //     slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
              //     {...item}
              //   />
              // )}
              />
            </Stack>
          </div>
          </>}
          {/* Crete Gate Entry Modal */}
          <Modal
            open={opengateentry}
            onClose={() => setOpenGateEntry(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenGateEntry(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_manager_bidding">
                  Are you sure you want to "<b>Create Gate Entry</b>" selected
                  LR?
                  <br />
                  LR No. : <b>LR0O1</b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenGateEntry(false);
                    }}
                  >
                    <Link
                      style={{ color: "black", textDecoration: "none" }}
                      to="/admin/vendor-Gate-Entry-Detail"
                    >
                      Yes
                    </Link>
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => setOpenGateEntry(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
        </div>
      </div>

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 99999999,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default LrListing;
